import React from 'react';

export function ActiveUsersLimitCardIcon() {
  return (
    <svg
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.985.003a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 00.002 12.21a11.78 11.78 0 0011.8 11.793h.214a12.111 12.111 0 0011.986-12.21A11.767 11.767 0 0011.985.004zm-1.483 16.542a1.473 1.473 0 011.449-1.53h.027a1.526 1.526 0 011.523 1.47 1.476 1.476 0 01-1.45 1.53h-.026a1.529 1.529 0 01-1.523-1.47zm.5-4.042v-6a1 1 0 112 0v6a1 1 0 01-2 0z"
        fill="#fff"
      />
    </svg>
  );
}

export function ActiveUsersLimitCardArrow() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.627 9a1.725 1.725 0 01-.585 1.297l-8.364 7.358a1.385 1.385 0 01-1.83-2.08l7.315-6.434a.19.19 0 00.064-.14.188.188 0 00-.064-.142L3.849 2.425A1.385 1.385 0 015.678.345l8.361 7.356a1.732 1.732 0 01.588 1.3z"
        fill="#fff"
      />
    </svg>
  );
}

export function AppModalCloseIcon() {
  return (
    <svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.533 8.12a.167.167 0 010-.237L15.71 1.71A1 1 0 0014.293.295L8.118 6.467a.167.167 0 01-.236 0L1.707.295A1 1 0 00.293 1.709l6.174 6.174a.167.167 0 010 .236L.293 14.295a1 1 0 101.414 1.414l6.175-6.176a.167.167 0 01.236 0l6.175 6.176a1 1 0 101.414-1.414L9.533 8.119z"
        fill="#24123a"
      />
    </svg>
  );
}

export function MicrophoneIcon({ enabled }: { enabled: boolean }) {
  return (
    <>
      {!enabled ? (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none">
          <path
            d="M8 13.333a5.005 5.005 0 01-5-5V6.667a.667.667 0 00-1.333 0v1.666a6.343 6.343 0 005.52 6.282c.084.01.146.081.146.165v.553a.667.667 0 101.333 0v-.553c0-.084.063-.155.146-.165a6.289 6.289 0 002.572-.934.166.166 0 00.03-.258l-.728-.728a.167.167 0 00-.2-.026A4.965 4.965 0 018 13.333z"
            fill="#24123a"
          />
          <path
            d="M4.285 6.298A.167.167 0 004 6.415v1.918a4 4 0 005.647 3.645.167.167 0 00.05-.267L4.285 6.298zM15.805 14.867l-2.635-2.635a.165.165 0 01-.018-.215 6.302 6.302 0 001.181-3.684V6.667a.667.667 0 00-1.333 0v1.666A4.972 4.972 0 0112.229 11a.166.166 0 01-.256.029l-.486-.485a.167.167 0 01-.026-.2c.355-.61.541-1.304.539-2.01V4a4 4 0 00-7.837-1.127.167.167 0 01-.278.07L1.138.2a.675.675 0 00-.943 0 .667.667 0 000 .943l14.667 14.666.005.005a.667.667 0 00.933-.95l.005.003z"
            fill="#24123a"
          />
        </svg>
      ) : (
        <svg
          width={13}
          height={16}
          viewBox="0 0 13 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.33 8.333a5.005 5.005 0 01-5 5V16a.667.667 0 00.667-.667v-.553c0-.084.062-.155.145-.165a6.343 6.343 0 005.521-6.282V6.667a.667.667 0 00-1.333 0v1.666z"
            fill="#24123a"
          />
          <path
            d="M1.333 8.333a5.005 5.005 0 005 5V16a.667.667 0 01-.666-.667v-.553a.166.166 0 00-.146-.165A6.343 6.343 0 010 8.333V6.667a.667.667 0 111.333 0v1.666z"
            fill="#24123a"
          />
          <path d="M10.33 4a4 4 0 00-8 0v4.35a4 4 0 008 0V4z" fill="#24123a" />
        </svg>
      )}
    </>
  );
}

export function CameraIcon({ enabled }: { enabled: boolean }) {
  return (
    <>
      {!enabled ? (
        <svg
          width={22}
          height={18}
          viewBox="0 0 22 18"
          fill="none"
          style={{ marginLeft: '-2px' }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.938 4.999a.75.75 0 00-.442.684v8.25c0 .414.336.75.75.75h9.376L3.938 4.999zm10.808 8.686V5.683a.75.75 0 00-.75-.75H5.993l8.753 8.752z"
            fill="#24123a"
          />
          <path
            d="M20.943 5.364a.375.375 0 00-.365-.016l-4.5 2.25a.375.375 0 00-.207.336v3.75c0 .141.08.271.207.335l4.5 2.25a.375.375 0 00.543-.335v-8.25a.375.375 0 00-.178-.32z"
            fill="#24123a"
          />
          <rect
            x={3.061}
            y={1}
            width={22}
            height={1.5}
            rx={0.75}
            transform="rotate(45 3.06 1)"
            fill="#24123a"
          />
        </svg>
      ) : (
        <svg width={18} height={11} viewBox="0 0 18 11" fill="none">
          <rect
            x={0.188}
            y={0.374}
            width={11.25}
            height={9.75}
            rx={0.75}
            fill="#24123a"
          />
          <path
            d="M17.635.805a.375.375 0 00-.366-.016l-4.5 2.25a.375.375 0 00-.207.336v3.75c0 .142.08.272.208.335l4.5 2.25a.375.375 0 00.543-.335v-8.25a.375.375 0 00-.178-.32z"
            fill="#24123a"
          />
        </svg>
      )}
    </>
  );
}

export function BtnCameraIcon() {
  return (
    <svg
      width={18}
      height={11}
      className="Navigation-btn-icon"
      viewBox="0 0 18 11"
      fill="none"
    >
      <rect x={0.188} y={0.374} width={11.25} height={9.75} rx={0.75} fill="#fff" />
      <path
        d="M17.635.805a.375.375 0 00-.366-.016l-4.5 2.25a.375.375 0 00-.207.336v3.75c0 .142.08.272.208.335l4.5 2.25a.375.375 0 00.543-.335v-8.25a.375.375 0 00-.178-.32z"
        fill="#fff"
      />
    </svg>
  );
}

export function AlertCardIcon() {
  return (
    <svg
      width={10}
      height={10}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#AlertCardIcon__clip0)">
        <path
          d="M4.994 0A5.086 5.086 0 001.448 1.52 4.917 4.917 0 000 5.086a4.908 4.908 0 004.916 4.913h.09A5.046 5.046 0 0010 4.912 4.901 4.901 0 004.994 0zm-.618 6.892a.615.615 0 01.603-.638h.012a.636.636 0 01.595.853.615.615 0 01-.565.397h-.01a.637.637 0 01-.635-.612zm.208-1.684v-2.5a.417.417 0 11.833 0v2.5a.417.417 0 11-.833 0z"
          fill="#E14816"
        />
      </g>
      <defs>
        <clipPath id="AlertCardIcon__clip0">
          <path fill="#fff" d="M0 0h10v10H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BtnCloseIcon() {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      className="Navigation-btn-icon"
    >
      <path
        d="M7.15 6.09a.125.125 0 010-.178l4.631-4.63A.75.75 0 1010.72.22L6.09 4.85a.125.125 0 01-.178 0L1.282.221A.75.75 0 10.22 1.281l4.63 4.631a.125.125 0 010 .178L.22 10.72a.75.75 0 001.06 1.06L5.912 7.15a.125.125 0 01.178 0l4.63 4.631a.75.75 0 101.062-1.06L7.15 6.09z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </svg>
  );
}

export function BtnTakeOverScreenIcon() {
  return (
    <svg
      width={21}
      height={15}
      viewBox="0 0 21 15"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: 'translateY(2px) translateX(-3.5px)' }}
    >
      <g fill="#FFF" fillRule="nonzero">
        <path d="M15 1.651A1.094 1.094 0 0013.819.562C9.617.94 5.389.94 1.187.563A1.098 1.098 0 000 1.651L.001 9.41a1.094 1.094 0 001.181 1.09c1.985-.16 3.55-.25 5.22-.274a.312.312 0 01.318.312v.78c0 .172-.14.312-.313.312H4.375a.781.781 0 100 1.563h6.25a.781.781 0 000-1.563H8.594a.312.312 0 01-.313-.313v-.778a.312.312 0 01.318-.313c1.67.026 3.235.115 5.222.275A1.094 1.094 0 0015 9.41V1.651zm-1.562 6.916a.313.313 0 01-.336.312 70.243 70.243 0 00-11.204 0 .313.313 0 01-.336-.312V2.495a.313.313 0 01.336-.313c3.729.298 7.475.298 11.204 0a.312.312 0 01.336.313v6.072z" />
        <path
          d="M10.298 4.269L20.47 7.991l-4.358 2.161-1.357 4.53-4.873-9.609c.143-.446.292-.68.416-.804h0z"
          stroke="#24123a"
          strokeWidth={0.833}
        />
      </g>
    </svg>
  );
}

export function GoProCardCheckIcon() {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 5.373 5.373 0 12 0c6.624.008 11.992 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12zm12.082 5.489L18.927 8.2a1 1 0 10-1.61-1.183l-6.227 8.451-4.076-3.261a1 1 0 00-1.25 1.562l4.888 3.908a1.011 1.011 0 001.43-.188z"
        fill="url(#GoProCardCheckIcon__paint0_linear)"
      />
      <defs>
        <linearGradient
          id="GoProCardCheckIcon__paint0_linear"
          x1={15.016}
          y1={33.825}
          x2={35.338}
          y2={7.928}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6A00" />
          <stop offset={1} stopColor="#FF4F00" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function GoProCardWifiIcon() {
  return (
    <svg
      width={113}
      height={159}
      viewBox="0 0 113 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={0.2}
        d="M117.717 37.17a9.288 9.288 0 00-4.807-17.94C51.027 35.895 14.304 99.5 30.814 161.426a9.286 9.286 0 0015.617 4.281 9.287 9.287 0 002.323-9.088C34.892 104.601 65.737 51.175 117.717 37.171z"
        fill="url(#GoProCardWifiIcon__paint0_linear)"
      />
      <path
        d="M85.038 154.81a9.288 9.288 0 006.566-11.374c-7.301-27.25 8.871-55.26 36.121-62.563a9.287 9.287 0 006.412-11.332 9.288 9.288 0 00-11.219-6.608c-37.158 9.958-59.209 48.152-49.254 85.311a9.288 9.288 0 0011.374 6.566z"
        fill="url(#GoProCardWifiIcon__paint1_linear)"
      />
      <defs>
        <linearGradient
          id="GoProCardWifiIcon__paint0_linear"
          x1={-7.678}
          y1={222.664}
          x2={94.751}
          y2={239.706}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6A00" />
          <stop offset={1} stopColor="#FF4F00" />
        </linearGradient>
        <linearGradient
          id="GoProCardWifiIcon__paint1_linear"
          x1={53.027}
          y1={188.552}
          x2={126.211}
          y2={196.263}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6A00" />
          <stop offset={1} stopColor="#FF4F00" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function NoActiveUsersIcon() {
  return (
    <svg
      width={47}
      height={35}
      viewBox="0 0 47 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.295 7.697c.448.414.704.996.705 1.605V24.82a2.188 2.188 0 01-2.359 2.181c-3.972-.319-7.103-.496-10.443-.549a.625.625 0 00-.636.625v1.558c0 .345.28.625.625.625h4.063a1.562 1.562 0 110 3.125h-12.5a1.563 1.563 0 010-3.125h4.063c.345 0 .625-.28.625-.625v-1.559a.625.625 0 00-.636-.625c-3.34.049-6.47.23-10.44.549A2.187 2.187 0 0111 24.82V9.302c.002-.61.259-1.191.707-1.605a2.139 2.139 0 011.668-.572c8.404.753 16.858.753 25.263 0a2.189 2.189 0 011.657.572zm-2.62 15.896a.625.625 0 00.2-.46V10.99a.625.625 0 00-.671-.625c-7.457.596-14.95.596-22.408 0a.625.625 0 00-.671.625v12.144a.625.625 0 00.671.625 140.49 140.49 0 0122.408 0 .625.625 0 00.472-.166z"
        fill="#8E93A4"
      />
      <path d="M4 2l41 28" stroke="#8E93A4" strokeWidth={4} />
      <path d="M2 5l41 28" stroke="#FBFBFB" strokeWidth={4} />
    </svg>
  );
}

export function OpenSiteBtnIcon() {
  return (
    <svg
      width={21}
      height={20}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: '5px', transform: 'translateY(3px)' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.522 13.422c.04.055.049.127.025.19-.129.362-.149.753-.058 1.126a.208.208 0 01-.038.179.21.21 0 01-.167.083H4.167a.833.833 0 110-1.667H6.25c.23 0 .417-.186.417-.416V12.5a.417.417 0 00-.417-.417H1.667c-.92 0-1.667-.746-1.667-1.666v-8.75C0 .747.746 0 1.667 0h11.666C14.253 0 15 .746 15 1.667V7.78a.204.204 0 01-.043.13l-3.278 4.095a.21.21 0 01-.167.078H8.75a.417.417 0 00-.417.417v.417c0 .23.187.416.417.416h1.6c.069 0 .133.033.172.089zM1.667 9.167c0 .23.186.416.416.416h10.834c.23 0 .416-.186.416-.416V2.083a.417.417 0 00-.416-.416H2.083a.417.417 0 00-.416.416v7.084z"
        fill="#fff"
      />
      <path
        d="M19.828 13.703a.73.73 0 00-.556-1.203h-1.563a.208.208 0 01-.208-.208V7.917a.417.417 0 00-.742-.261l-4.917 6.141A.73.73 0 0012.397 15h1.562c.115 0 .209.093.209.208v4.375a.417.417 0 00.741.26l4.918-6.14z"
        fill="#fff"
      />
    </svg>
  );
}
export function AttentionIcon() {
  return (
    <svg
      width={46}
      height={47}
      viewBox="0 0 46 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="LimitModal__icon"
    >
      <path
        d="M22.968.634A23.304 23.304 0 006.66 7.69a22.81 22.81 0 00-4.998 7.579 22.956 22.956 0 00-1.658 8.945c-.004 2.994.58 5.96 1.715 8.726a22.768 22.768 0 004.902 7.396 22.563 22.563 0 007.34 4.937 22.419 22.419 0 008.658 1.723h.41a23.122 23.122 0 0016.324-7.004A23.495 23.495 0 0046 23.412a22.887 22.887 0 00-1.747-8.827 22.74 22.74 0 00-5.01-7.451 22.532 22.532 0 00-7.485-4.907A22.391 22.391 0 0022.968.634zM20.127 32.59a2.873 2.873 0 01.773-2.066 2.828 2.828 0 012.004-.89h.052a2.915 2.915 0 012.027.827c.544.53.864 1.251.892 2.013a2.87 2.87 0 01-.772 2.066 2.828 2.828 0 01-2.005.89h-.052a2.918 2.918 0 01-2.026-.829 2.965 2.965 0 01-.893-2.011zm.959-7.809v-11.59c0-.513.201-1.004.56-1.367a1.909 1.909 0 012.711 0c.36.363.562.854.562 1.366v11.591a1.94 1.94 0 01-.562 1.366 1.909 1.909 0 01-2.71 0 1.94 1.94 0 01-.561-1.366z"
        fill="#E14816"
      />
    </svg>
  );
}
